import React from 'react';

interface Layout {
  children: React.ReactNode;
}

export const Layout = ({ children}: Layout) => {
  return (
    <div className="flex flex-row w-full min-h-screen bg-white">
      <div className="flex-1 flex flex-col relative min-h-full bg-slate-200 max-h-[100vh] overflow-auto bg-white">
        <div className="grow-0 basis-10 flex mx-10 my-3 ">
          <div className="flex-1 flex flex-col justify-center">
          </div>
        </div>
        <div className="flex-1 flex flex-col relative max-h-[100vh] overflow-auto p-10 pt-5">
          {children}
        </div>
      </div>
    </div>
  );
};
